import Dexie, { type EntityTable } from 'dexie';
import type { ObservationRecord } from '@/lib/state/types';

/**
 * Local persistence for in-progress and submitted observations.
 *
 * Dexie v4 / IndexedDB under the hood. Much larger quota than localStorage
 * and handles the ~60 KB / observation footprint comfortably.
 */

class FccersDb extends Dexie {
  observations!: EntityTable<ObservationRecord, 'id'>;

  constructor() {
    super('fccers-tool');
    this.version(1).stores({
      observations: 'id, status, updatedAt, submittedAt',
    });
  }
}

export const db = new FccersDb();

export async function listObservations(): Promise<ObservationRecord[]> {
  return db.observations.orderBy('updatedAt').reverse().toArray();
}

export async function getObservation(
  id: string,
): Promise<ObservationRecord | undefined> {
  return db.observations.get(id);
}

export async function upsertObservation(
  record: ObservationRecord,
): Promise<void> {
  await db.observations.put(record);
}

export async function deleteObservation(id: string): Promise<void> {
  await db.observations.delete(id);
}
